import type { HelpFile } from '../../types/help'
import { NotificationBellTestIds } from '../../../testids/NotificationBellTestIds'

export const notificationBellHelp: HelpFile = {
  docPage: '/docs/my-iam/notifications',
  texts: {
    [NotificationBellTestIds.notificationBell]: null,
    [NotificationBellTestIds.unreadBadge]: null,
    [NotificationBellTestIds.markAllRead]:
      'Alle sichtbaren Benachrichtigungen auf einmal als gelesen markieren.',
    [NotificationBellTestIds.viewAllNotifications]:
      'Vollständigen Benachrichtigungsverlauf mit Filtern und Details öffnen.',
  },
}
